module.exports = __webpack_public_path__ + "static/img/a07.f3b0edcb.jpg";